module.exports = __webpack_public_path__ + "static/img/2-active.0f708c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/2-active.png
// module id = WDG3
// module chunks = 0